import styled from 'styled-components';

import Icon from '../Icon';
import Paragraph from '../Paragraph';

const borderColor = {
  info: 'wfBlue',
  error: 'wfOrange',
  warning: 'wfYellow',
  success: 'wfGreen',
};

const backgroundColor = {
  info: 'wfBlue100',
  error: 'wfOrange100',
  warning: 'wfYellow100',
  success: 'wfGreen100',
};

const fontColor = {
  info: 'wfBlue',
  error: 'wfOrange',
  warning: 'wfBlack',
  success: 'wfGreen',
};

export const BannerStyled = styled.div`
  position: relative;
  display: ${props =>
    props.isInline || props.isShorted ? 'inline-flex' : 'flex'};
  align-items: center;
  justify-content: ${props => props.isFixed && 'center'};
  text-align: ${props => props.isFixed && 'center'};
  padding: ${props => (props.isShorted ? '0.5em' : `0.7em 1em`)};
  padding-right: ${props => props.isDismissable && '2em'};
  margin: ${props => !props.isFixed && `${props.theme.spacing.default} 0`};
  border: ${props => !props.isFixed && !props.customBgColor && '1px solid'};
  border-color: ${props => props.theme.color[borderColor[props.variant]]};
  background-color: ${props =>
    props.customBgColor
      ? props.customBgColor
      : props.theme.color[backgroundColor[props.variant]]};
  color: ${props =>
    props.customBgColor
      ? props.theme.color.wfBlack
      : props.theme.color[fontColor[props.variant]]};
  font-size: ${props => props.theme.font.size[props.size]};
  a {
    color: currentColor;
    text-decoration: underline;
  }
`;

export const ParagraphStyled = styled(Paragraph)`
  color: currentColor;
  flex: 1;
  > a {
    cursor: pointer;
    font-weight: ${props => props.theme.font.weight.xbold};
  }
`;

export const IconStyled = styled(Icon)`
  width: 1.3em;
  height: 1.3em;
  margin-right: ${props => !props.isShorted && '1em'};
`;

export const IconCloseStyled = styled(Icon)`
  width: 0.8em;
  height: 0.8em;
  cursor: pointer;
  margin-left: auto;
`;

export const BannerContent = styled.div`
  margin-right: ${props => props.isDismissable && '1em'};
  margin-left: ${props => props.isFixed && props.isDismissable && 'auto'};
  flex: 1;
  display: flex;
  align-items: center;
`;
